// TODO ISO 27001: pasar signal a axiosPost cuando soporte el tercer param options.

import { log } from "utils/logger";
import axiosPost from "services/services-mia/axiosPost";
import { SSE_URL } from "consts/env";

export { getStreamHeaders } from "services/services-mia/getStreamHeaders";

const REQUEST_TIMEOUT_MS = 15000;

function withTimeout(signal, ms = REQUEST_TIMEOUT_MS) {
    const ctrl = new AbortController();
    const timeoutId = setTimeout(() => {
        ctrl.abort(new DOMException("Request timeout", "AbortError"));
    }, ms);
    if (signal) {
        if (signal.aborted) ctrl.abort();
        else signal.addEventListener("abort", () => ctrl.abort(), { once: true });
    }
    return {
        signal: ctrl.signal,
        cleanup: () => clearTimeout(timeoutId),
    };
}

function throwSanitized(label, response, detailContext = "") {
    log.error(`[registros] ${label} fallo [status=${response.status}], contexto=${detailContext}`);
    const err = new Error(`No se pudo ${label.toLowerCase()}`);
    err.status = response.status;
    return err;
}

export const SSE_STREAM_URL = `${SSE_URL}/gate-monitor/stream`;

// const USE_MOCK = false

export const gateMonitorGet = async ({
    page = null,
    pageSize = null,
    fecha = null,
    credentials,
    gateLugarId,
    signal,
}) => {
    // if (USE_MOCK) {
    //     return {
    //         rows: MOCK_GATE_MONITOR_EVENTO_GET.result,
    //         total: MOCK_GATE_MONITOR_EVENTO_GET.status.id,
    //     };
    // }

    const body = {
        service: "GateMonitorEventoGet",
        params: {
            ...(page !== null && { page }),
            ...(pageSize !== null && { pageSize }),
            ...(fecha !== null && { fecha }),
            ...(gateLugarId?.length && { gateLugarId: JSON.stringify(gateLugarId) }),
        },
    };

    const result = await axiosPost(body, credentials);

    if (result?.status?.code !== 1) {
        log.error(`[registros] GateMonitorEventoGet rechazado [errcode=${result?.status?.errcode}]`);
        throw new Error("No se pudieron obtener los registros");
    }

    return {
        rows: Array.isArray(result.result) ? result.result : [],
        total: result.status?.id > 0
            ? result.status.id
            : (Array.isArray(result.result) ? result.result.length : 0),
    };
};

export const gateDetalleGet = async ({ id, credentials }) => {
    const body = {
        service: "GateESHistoGet",
        params: { gateESHistoId: id },
    };

    const result = await axiosPost(body, credentials);

    if (result?.status?.code !== 1) {
        log.error(`[registros] GateESHistoGet rechazado [errcode=${result?.status?.errcode}]`);
        throw new Error("No se pudo obtener el detalle");
    }

    return result.result?.[0] ?? null;
};